export default "__VITE_ASSET__TevoU2Ah__"